import { Card } from "@/design-system/Card";
import { Inline } from "@/design-system/Inline";
import { Text } from "@/design-system/Text";

import { Lightbulb02Icon } from "../Icons/Lightbulb02Icon";

interface AskNobiSuggestionButtonProps {
  children: string;
  onClick: () => void;
}

/** Product-owned example prompt shared by the Ask Nobi page and drawer. */
export function AskNobiSuggestionButton({ children, onClick }: AskNobiSuggestionButtonProps): React.ReactNode {
  return (
    <Card as="button" type="button" density="compact" interactive onClick={onClick}>
      <Inline align="center" gap="sm" wrap={false}>
        <span className="flex size-control-md shrink-0 items-center justify-center rounded-label-xs bg-background-brand-tertiary-light text-text-brand">
          <span className="size-icon-inline">
            <Lightbulb02Icon />
          </span>
        </span>
        <Text variant="caption">{children}</Text>
      </Inline>
    </Card>
  );
}
